/* CK add-ons + Dawn-native add UX (drawer OR popup) — no redirects, no reloads */
(function () {
  if (window.__ckKitInit) return;
  window.__ckKitInit = true;

  let adding = false;

  // ---------- helpers ----------
  const euros = (n) => Number(n).toFixed(2);

  function findProductSection(el) {
    return el.closest('[id^="ProductInfo-"], section[data-section], product-info, .product__info-container');
  }
  function qtyFor(sectionEl) {
    const q = Number(sectionEl?.querySelector('input[name="quantity"]')?.value || 1);
    return isNaN(q) || q < 1 ? 1 : q;
  }

  function ensureNoSelected(box) {
    const sec = box.dataset.sec;
    const checked = box.querySelector(`input[name="kit_patch_${sec}"]:checked`);
    if (!checked) {
      const no = box.querySelector('[data-none="true"]');
      if (no) no.checked = true;
    }
  }

  function priceNote(box, sectionEl) {
    const backEl   = box.querySelector('[name="properties[Back]"]');
    const backText = (backEl?.value || '').trim();
    const sec      = box.dataset.sec;

    const chosen     = box.querySelector(`input[name="kit_patch_${sec}"]:checked`);
    const patchExtra = Number(chosen?.dataset.addonPrice || 0);
    const patchName  = chosen?.value || 'No';

    const wantBack = !!backText;
    const nnExtra  = wantBack ? 5 : 0;

    const perUnit    = nnExtra + patchExtra;
    const qty        = qtyFor(sectionEl);
    const totalExtra = perUnit * qty;

    const note = box.querySelector('.ck-hint');
    if (!note) return;

    if (!wantBack && (!chosen || patchName === 'No')) {
      note.textContent = 'Checkout shows: product price (no customization selected yet)';
      return;
    }

    const parts = [];
    if (wantBack) parts.push('Back name & number €5');
    if (patchName && patchName !== 'No') parts.push(`${patchName} patch €5`);

    const txt = parts.join(' + ');
    note.textContent =
      qty > 1
        ? `Customization will add €${euros(totalExtra)} ( ${txt} × ${qty} )`
        : `Customization will add €${euros(perUnit)} (${txt})`;
  }

  function initBox(box) {
    if (!box || box.__ckInit) return;
    box.__ckInit = true;

    const sectionEl = findProductSection(box);
    ensureNoSelected(box);
    priceNote(box, sectionEl);

    box.addEventListener('change', (e) => {
      if (e.target.name?.startsWith('kit_patch_') || e.target.name === 'properties[Back]') {
        priceNote(box, sectionEl);
      }
    });

    sectionEl?.querySelector('input[name="quantity"]')
      ?.addEventListener('input', () => priceNote(box, sectionEl));
  }

  function initAll() { document.querySelectorAll('.ck-kit-box').forEach(initBox); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else { initAll(); }
  document.addEventListener('shopify:section:load', initAll);

  // ---------- sections to request ----------
  function sectionsForAdd() {
    const wants = ['cart-icon-bubble'];
    const hasDrawer = !!document.querySelector('cart-drawer');
    const hasPopup  = !!document.querySelector('cart-notification');

    if (hasDrawer) {
      // Dawn Cart Drawer
      wants.push('cart-drawer');
    } else if (hasPopup) {
      // Dawn Popup Notification
      wants.push('cart-notification-product', 'cart-notification-button');
    }
    return wants;
  }

  // ---------- render with Dawn’s own components ----------
  function renderWithDawn(data) {
    const sections = data.sections || {};
    const drawer   = document.querySelector('cart-drawer');
    const popup    = document.querySelector('cart-notification');

    // Drawer active → render drawer
    if (drawer && sections['cart-drawer']) {
      if (typeof drawer.renderContents === 'function') {
        drawer.renderContents({ sections });
      } else {
        drawer.innerHTML = sections['cart-drawer'];
        drawer.classList.add('is-open');
      }
      return;
    }

    // Popup active → render popup
    if (popup && sections['cart-notification-product']) {
      // Pick the first returned item key so the snippet highlights it
      const firstKey = (Array.isArray(data.items) && data.items[0] && data.items[0].key) ? data.items[0].key : '';
      if (typeof popup.renderContents === 'function') {
        popup.renderContents({ key: firstKey, sections });
      } else {
        // very old fallback
        document.getElementById('cart-notification-product').innerHTML =
          new DOMParser().parseFromString(sections['cart-notification-product'], 'text/html')
            .querySelector('.shopify-section').innerHTML;
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) bubble.innerHTML = sections['cart-icon-bubble'];
        popup.classList.add('active');
      }
      return;
    }

    // If neither exists, do nothing (theme set to "cart page")
  }

  // ---------- POST bundle (atomic) ----------
  async function postBundle(items) {
    if (adding) return false;
    adding = true;
    setTimeout(() => (adding = false), 1200);

    const qs = new URLSearchParams({
      sections: sectionsForAdd().join(','),
      sections_url: window.location.pathname
    });

    const res = await fetch(`/cart/add.js?${qs.toString()}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });

    const data = await res.json();
    if (!res.ok) {
      console.error('[CK] /cart/add.js failed', data);
      alert((data && data.description) || 'Could not add to cart.');
      return false;
    }

    renderWithDawn(data); // <- hand off to Dawn UI (drawer OR popup)
    return true;
  }

  // ---------- intercept add only when kit UI is present ----------
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('button[name="add"], button[type="submit"]');
    if (!btn) return;

    const sectionEl = findProductSection(btn);
    if (!sectionEl) return;

    const box = sectionEl.querySelector('.ck-kit-box');
    if (!box) return; // no add-ons here → let Dawn handle everything

    e.preventDefault();
    e.stopPropagation();

    const form   = sectionEl.querySelector('form[action*="/cart/add"]');
    const idEl   = form?.querySelector('input[name="id"]');
    if (!idEl?.value) return;

    const qty = qtyFor(sectionEl);

    ensureNoSelected(box);
    const backEl      = box.querySelector('[name="properties[Back]"]');
    const backText    = (backEl?.value || '').trim();
    const sec         = box.dataset.sec;
    const chosenPatch = box.querySelector(`input[name="kit_patch_${sec}"]:checked`);

    const nnVariantId    = Number(box.dataset.nnVariantId || 0);
    const patchVariantId = Number(chosenPatch?.dataset.addonVariantId || 0);

    const bundleId = Date.now().toString(36);

    // Parent
    const parentProps = { _bundle_parent: 'true', _bundle_id: bundleId };
    if (backText) parentProps.Back = backText;
    if (chosenPatch) parentProps.Patch = chosenPatch.value;

    const items = [{
      id: Number(idEl.value),
      quantity: qty,
      properties: parentProps
    }];

    // Add-ons (locked)
    if (backText && nnVariantId) {
      items.push({
        id: nnVariantId,
        quantity: qty,
        properties: { _bundle_id: bundleId, _type: 'name-number', _locked: 'true' }
      });
    }
    if (patchVariantId) {
      items.push({
        id: patchVariantId,
        quantity: qty,
        properties: { _bundle_id: bundleId, _type: 'patch', _locked: 'true' }
      });
    }

    await postBundle(items);
  }, { capture: true });
})();
